<template>
  <div class="list">
    <el-checkbox-group
      v-model="checkedLists"
      v-show="listData.length !== 0"
      :max="max"
      @change="handleCheckedListsChange"
    >
      <dl
        :class="['item', { active: index + 1 === active }]"
        v-for="(item, index) in listData"
        :key="index"
        @click="changeSelected(index)"
      >
        <dt v-show="item.articletypeid === 6||item.coverpicurl">
          <el-image
            fit="cover"
            :src="item.articletypeid === 6 ? audioBg : item.coverpicurl"
            referrerpolicy="no-referrer"
          >
            <div
              slot="placeholder"
              class="image-slot image-placeholder"
            >
              加载中
              <span class="dot">...</span>
            </div>
            <div
              slot="error"
              class="image-slot"
            >
              <img
                :src="loadError"
                style="width:100%"
              >
            </div>
          </el-image>
        </dt>
        <dd>
          <div class="item_detail">
            <h5>
              <el-checkbox
                v-if="isShowChecked"
                :label="item.id"
                @click.stop.native
              />
              <span
                :class="['number', item.topicIndex <= 3 ? 'highlight' : '']"
              >{{ item.topicIndex }}</span>
              <span class="type">{{ typeObj[item.articletypeid] }}</span>
              <span
                :class="['status', `status-${item.status}`]"
                v-show="isShowStatus"
              >{{ statusObj[item.status] }}</span>
              <h6
                v-html="item.title"
                :title="item.title | removeTagEm"
              />
            </h5>
            <p v-html="item.description" />
          </div>
          <div class="intro">
            <span
              v-show="item.articletypeid === 2"
              class="pic_count"
            ><i class="icon icon-jlxk-img-count" />{{ item.hasPic }}</span>
            {{ item.created | filterDate }}&nbsp;&nbsp;<span
              v-show="item.department !== ''"
            >|</span>&nbsp;&nbsp;{{ item.department }}
          </div>
        </dd>
      </dl>
    </el-checkbox-group>
    <div
      class="emtpy"
      v-show="listData.length === 0"
    >
      {{ empty }}
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    empty: {
      type: String,
      default: ''
    },
    checkedData: {
      type: Array,
      default: () => []
    },
    isShowChecked: {
      type: Boolean,
      default: false
    },
    isShowStatus: {
      type: Boolean,
      default: true
    },
    max: {
      type: Number,
      default: Infinity
    }
  },
  data() {
    return {
      checkedLists: [],
      typeObj: {
        1: '图文',
        2: '图集',
        6: '音频',
        5: '视频',
        3: '书籍文件',
        4: '影视作品'
      },
      statusObj: {
        1: '处理中',
        2: '草稿',
        3: '待提交',
        4: '提交待审',
        5: '通过',
        6: '退回'
      },
      audioBg: require('@assets/imgs/jlxk/audio-bg.png'),
      active: 1,
      loadError: require('@assets/imgs/loadError.png')
    }
  },
  filters: {
    filterDate(date) {
      return date.slice(5)
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleCheckedListsChange() {
      this.$emit('handleCheckedListsChange', this.checkedLists)
    },
    changeSelected(index) {
      this.active = index + 1
      this.$emit('changeSelected', index)
    }
  },
  watch: {
    checkedData: {
      handler(newVal) {
        this.checkedLists = [...newVal]
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  margin-top: 10px;
  .check-all {
    position: fixed;
    top: 0;
    .el-checkbox__label {
      padding-left: 9px;
    }
  }
  /deep/ .el-checkbox-group {
    .item {
      position: relative;
      display: flex;
      padding: 18px 17px 18px 25px;
      justify-content: space-between;
      border-bottom: 1px dashed #dbdbdb;
      &:hover,
      &.active {
        background-color: #edf0f7;
      }
      dt {
        width: 150px;
        flex-shrink: 0;
        margin-right: 16px;
        height: 100px;
        .el-image {
          width: 100%;
          height: 100px;
          .image-slot {
            max-height: 100%;
          }
          &__inner {
            width: 100%;
            height: 100px;
            border-radius: 5px;
          }
          .image-placeholder {
            width: 100%;
            height: 100%;
            background-color: #f0f0f0;
            display: flex;
            font-size: 12px;
            align-items: center;
            justify-content: center;
          }
        }
      }
      dd {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 0;
        flex: 1;
        .el-checkbox__label {
          display: none;
        }
        span.status,
        span.type {
          flex-shrink: 0;
          display: inline-block;
          margin-right: 5px;
          padding: 0 5px;
          font-size: 12px;
          color: #fff;
          border-radius: 3px;
          height: 16px;
          line-height: 16px;
          background: #28a2d5;
        }
        span.status-1,
        span.status-4 {
          background-color: #46bdb3;
        }
        span.status-2 {
          background-color: #f77535;
        }
        span.status-5 {
          background-color: #61d269;
        }
        span.status-6 {
          background-color: #e14646;
        }
        .number {
          padding: 0 4px;
          height: 16px;
          text-align: center;
          line-height: 16px;
          background: #999999;
          margin-right: 5px;
          border-radius: 3px;
          font-size: 14px;
          color: #fff;
          &.non-cover {
            margin-right: 5px;
          }
          &.highlight {
            background-color: #fd9b1c;
          }
        }
        .el-checkbox {
          margin-right: 10px;
        }
        h5 {
          display: flex;
          font-size: 14px;
          margin: 0 0 8px 0;
          color: #333;
          align-items: center;
          h6 {
            cursor: pointer;
            word-break: break-all;
            @extend .ellipsis;
            em {
              font-style: normal;
              color: #ee5848;
            }
          }
        }
        p {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          max-height: 44px;
          overflow: hidden;
          font-size: 13px;
          color: #666;
          line-height: 20px;
          word-break: break-all;
          em {
            font-style: normal;
            color: #ee5848;
          }
        }
        .intro {
          margin-top: 5px;
          line-height: 22px;
          color: #4497ec;
          font-size: 14px;
          .pic_count {
            display: inline-flex;
            padding: 0 7px 0 5px;
            margin-right: 9px;
            height: 18px;
            align-items: center;
            background: #eeeeee;
            border-radius: 3px;
            i {
              margin-right: 6px;
            }
          }
        }
      }
    }
  }
  .emtpy {
    text-align: center;
    padding: 50px 0;
    font-size: 13px;
    color: #666;
  }
}
</style>
